var map = {
	"./between-heaven-and-earth.json": "4d4d",
	"./make-your-own-law.json": "c072",
	"./puzzling-poetry-treasure-chest.json": "1f3e",
	"./thinking-outside-the-box.json": "2b38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c72";